import React from 'react';
import { Button, Modal } from 'antd';
import { ExclamationCircleFilled } from '@ant-design/icons';
import { ReadOnlyGuard } from '@spark';

import './DuplicateEcrPushConfirmModal.css';

/** Must sit above ConfigureDeploymentModal (2100) and its mask. */
const DUPLICATE_ECR_PUSH_CONFIRM_Z_INDEX = 3000;

function formatTargetLabel(previousPush) {
  if (!previousPush) return 'the target repository';
  if (previousPush.alias) {
    return `${previousPush.alias} (${previousPush.repositoryUri || previousPush.imageRef || ''})`;
  }
  return previousPush.repositoryUri || previousPush.imageRef || 'the target repository';
}

export default function DuplicateEcrPushConfirmModal({
  open,
  previousPush,
  onCancel,
  onConfirm,
  confirmLoading = false,
}) {
  const pushedAt = previousPush?.pushedAt
    ? new Date(previousPush.pushedAt).toLocaleString()
    : 'previously';
  const targetLabel = formatTargetLabel(previousPush);

  return (
    <Modal
      className="duplicate-ecr-push-confirm-modal"
      rootClassName="duplicate-ecr-push-confirm-modal-root"
      open={open}
      onCancel={onCancel}
      centered
      width={520}
      zIndex={DUPLICATE_ECR_PUSH_CONFIRM_Z_INDEX}
      maskClosable={false}
      destroyOnClose
      title={
        <span className="duplicate-ecr-push-confirm-modal__title">
          <ExclamationCircleFilled className="duplicate-ecr-push-confirm-modal__icon" aria-hidden />
          Image already pushed
        </span>
      }
      footer={[
        <Button key="cancel" onClick={onCancel} disabled={confirmLoading}>
          Cancel
        </Button>,
        <ReadOnlyGuard key="confirm">
          <Button type="primary" onClick={onConfirm} loading={confirmLoading}>
            Push anyway
          </Button>
        </ReadOnlyGuard>,
      ]}
    >
      <p className="duplicate-ecr-push-confirm-modal__body">
        This image was already pushed to {targetLabel} on{' '}
        <strong>{pushedAt}</strong>. Pushing again will overwrite the existing tag. Do you want
        to push anyway?
      </p>
    </Modal>
  );
}
